// Base colors for charts
export const CHART_COLORS = {
  // Tracked Time Chart
  trackedTime: {
    bar: '#1976D2',
    hover: '#1565C0',
  },

  // Activity Chart
  activity: {
    clicks: '#FF6B6B',
    keyPress: '#4ECDC4',
    mouseActivity: '#45B7D1',
  },

  // Attendance Chart
  attendance: {
    primary: '#10b981', // Green for present
    secondary: '#6b7280', // Gray for absent
    average: '#3b82f6', // Blue for average line
    // Color palette for individual users
    users: [
      '#3b82f6', // Blue
      '#ef4444', // Red
      '#f59e0b', // Amber
      '#10b981', // Green
      '#8b5cf6', // Purple
      '#ec4899', // Pink
      '#06b6d4', // Cyan
      '#14b8a6', // Teal
      '#f97316', // Orange
      '#84cc16', // Lime
      '#6366f1', // Indigo
      '#a855f7', // Violet
    ],
  },

  // Application Usage Chart
  applicationUsage: {
    // Predefined colors for commonly used applications
    common: {
      'Google Chrome': '#4285F4',
      'Microsoft Edge': '#0078D7',
      'Visual Studio Code': '#007ACC',
      'Microsoft Teams': '#6264A7',
      Slack: '#4A154B',
      Terminal: '#4D4D4D',
    },
    // Parameters for generating colors for other applications
    generated: {
      saturation: 70,
      lightness: 50,
    },
  },
} as const;

// Function to generate color based on string
export function stringToColor(str: string): string {
  // First check if there is a predefined color
  const predefinedColor =
    CHART_COLORS.applicationUsage.common[str as keyof typeof CHART_COLORS.applicationUsage.common];
  if (predefinedColor) {
    return predefinedColor;
  }

  // If not, generate color
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash % 360);
  const { saturation, lightness } = CHART_COLORS.applicationUsage.generated;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
